export const NO_SUBSCRIPTION = 'No Subscription';
export const subscriptionTierMap = {
  basic: 0,
  plus: 1,
  core: 1,
  boost: 2,
  pro: 2,
  vip: 2,
  unlimited: 3
} as const;

export enum TierMap {
  MELIO_ACCOUNTING_CLIENT_CORE = 'Firm Core',
  MELIO_ACCOUNTING_CLIENT_BOOST = 'Firm Boost',
  MELIO_ACCOUNTING_CLIENT_UNLIMITED_ACH = 'Firm Unlimited',
  MELIO_UNLIMITED_FREE_TRIAL = 'Melio Unlimited Free Trial',
  MELIO_BASIC = 'Go',
  MELIO_PLUS = 'Core',
  MELIO_PRO = 'Boost',
  MELIO_UNLIMITED_ACH = 'Unlimited',
  MELIO_VIP = 'VIP',
  MELIO_ACCOUNTING_FIRM = 'Accounting VIP'
}
export type TierColors = {
  background: string;
  text: string;
};

export const subscriptionTierColorMap: Record<string, TierColors> = {
  NO_SUBSCRIPTION: { background: '#F1F5F8', text: '#18191B' },
  MELIO_BASIC: { background: '#F1F5F8', text: '#18191B' },
  MELIO_UNLIMITED_FREE_TRIAL: { background: '#F1F5F8', text: '#18191B' },
  MELIO_PLUS: { background: '#E6FFFB', text: '#18191B' },
  MELIO_ACCOUNTING_CLIENT_CORE: { background: '#E6FFFB', text: '#18191B' },
  MELIO_PRO: { background: '#F9F0FF', text: '#391085' },
  MELIO_ACCOUNTING_CLIENT_BOOST: { background: '#F9F0FF', text: '#391085' },
  MELIO_UNLIMITED_ACH: { background: '#FFF0F6', text: '#9E1068' },
  MELIO_ACCOUNTING_CLIENT_UNLIMITED_ACH: {
    background: '#FFF0F6',
    text: '#9E1068'
  },
  MELIO_VIP: { background: '#E6F4FF', text: '#003EB3' },
  MELIO_ACCOUNTING_FIRM: { background: '#E6F4FF', text: '#003EB3' }
};

export const ACCOUNTING_CLIENT = 'accounting_client';

export const ACCOUNTING_TIER_PREFIX = 'Accounting';

export const NO_VALUE = 'N/A';
